import i18n from '../../managers/i18n'

i18n.register(
  'zh-Hans',
  {
    done: '完成',
    error: '错误'
  },
  {
    ns: 'progress'
  }
)
